import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const CtaSection2 = () => {
  const { t } = useTranslation();
  return (
    <section className="fz-5-cta-section fz-5-cta-section-2">
      <div className="container">
        <div className="row align-items-center">

          <div className="col-md-6">
            <div className="fz-5-cta-txt">
              <h3>{t("Contact lenses")}</h3>
              <h2>{t('Unparalleled comfort')}</h2>
              <Link to="/shop" className="fz-5-def-btn">
              {t('shop_now')}
              </Link>
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 col-md-3">
            <div className="fz-5-cta-img">
              <img src="assets/images/fz-5-cta-img-2.webp" alt="Image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection2;
